/**
 * Header Configuration Constants
 * Quản lý cấu hình header fixed cho các trang khác nhau
 */

export interface HeaderFixedConfig {
  /** Các prefix URL mà header sẽ được fixed */
  fixedPrefixes: string[]
  /** Các exact path mà header sẽ được fixed */
  fixedExactPaths: string[]
  /** Các prefix URL mà header sẽ KHÔNG được fixed */
  excludedPrefixes: string[]
  /** Các exact path mà header sẽ KHÔNG được fixed */
  excludedExactPaths: string[]
}

/**
 * Cấu hình header fixed cho từng locale
 */
export const HEADER_FIXED_CONFIG: Record<string, HeaderFixedConfig> = {
  vi: {
    fixedPrefixes: [],
    fixedExactPaths: [
      "/vi",
      "/",
      "/vi/tours-vi",
      "/tours",
      "/bike-rental",
      "/vi/bike-rental-vi",
      "/en-self-guieded-tour-new",
      "/vi/self-guided-tour-vi",
      "/bike-rental",
      "/vi/bike-rental-vi",
      "/all-tours",
      "/vi/all-tours-vi",
      "/vi/self-guided-tour-vi",
    ],
    excludedPrefixes: ["/vi/admin", "/vi/login", "/vi/ui-builder"],
    excludedExactPaths: [],
  },
  en: {
    fixedPrefixes: [],
    fixedExactPaths: [
      "/en",
      "/",
      "/vi/tours-vi",
      "/tours",
      "/bike-rental",
      "/vi/bike-rental-vi",
      "/en-self-guieded-tour-new",
      "/vi/self-guided-tour-vi",
      "/bike-rental",
      "/vi/bike-rental-vi",
      "/all-tours",
      "/vi/all-tours-vi",
      "/vi/self-guided-tour-vi",
    ],
    excludedPrefixes: ["/en/admin", "/en/login", "/en/ui-builder"],
    excludedExactPaths: [],
  },
}

/**
 * Default configuration khi không tìm thấy locale
 */
export const DEFAULT_HEADER_CONFIG: HeaderFixedConfig = {
  fixedPrefixes: ["/blog", "/tour", "/media", "/about", "/contact", "/services"],
  fixedExactPaths: [
    "/",
    "/vi/tours-vi",
    "/tours",
    "/bike-rental",
    "/vi/bike-rental-vi",
    "/en-self-guieded-tour-new",
    "/vi/self-guided-tour-vi",
    "/bike-rental",
    "/vi/bike-rental-vi",
    "/all-tours",
    "/vi/all-tours-vi",
    "/vi/self-guided-tour-vi",
  ],
  excludedPrefixes: ["/admin", "/login", "/ui-builder"],
  excludedExactPaths: [],
}
